const coupon = {
  props: {
    dynamicClass: ".c-coupon.dynamicLoading",
    ctaSelector: "coupon-cta-JS",
  },

  init: function (baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-coupon.css", this.props.dynamicClass);

    if (bcl.editMode) {
      return;
    }

    const baseFind = baseDom ? baseDom : document,
      elements = baseFind.getElementsByClassName(this.props.ctaSelector);

    bcl.u.forEach(elements, this.initItem.bind(this));
  },

  initItem: function ($coupon) {
    if (!$coupon.dataset.value) {
      return;
    }

    $coupon.addEventListener("click", () => {
      bcl.c.fastbooking.discount.addPromocode($coupon.dataset.value);

      this.active($coupon);
    });

    if (bcl.c.fastbooking.commonProps.discount.data && bcl.c.fastbooking.commonProps.discount.data.promocode && $coupon.dataset.value === bcl.c.fastbooking.commonProps.discount.data.promocode.value) {
      this.active($coupon);
    }
  },

  active: function ($coupon) {
    bcl.u.addClass($coupon, "hidden");

    const $active = $coupon.parentNode.querySelector(".c-coupon-compact__active");

    if ($active) {
      bcl.u.removeClass($active, "hidden");
    }
  },
};

export default coupon;
